<template>
    <svg :width="size" :height="size" xmlns="http://www.w3.org/2000/svg">
    <g fill="#000" fill-rule="nonzero">
        <path d="M87.799 42.71l5.657 5.657L48.2 93.622l-5.657-5.657z"/>
        <path d="M93.456 87.965l-5.324 5.324-45.255-45.254L48.2 42.71z"/>
        <path d="M68 136c37.555 0 68-30.445 68-68S105.555 0 68 0 0 30.445 0 68s30.445 68 68 68zm0-8c-33.137 0-60-26.863-60-60S34.863 8 68 8s60 26.863 60 60-26.863 60-60 60z"/>
    </g>
    </svg>
</template>
<script>
export default {
    name: "IconRejection",
    props: {
        size: {
            type: Number,
            default: 136,
        },
    },
};
</script>